import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=b84d0198&"
import script from "./recordDetail.vue?vue&type=script&lang=ts&"
export * from "./recordDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports